import React from "react";
import portFolioImage from "../static/images/portfolioProfileImage.png";
import linkGIF from "../static/images/linkGif.gif";
function BodyDescription() {
  return (
    <div className="bodyDescriptionCard mb-xl-5 mb-lg-5 mb-md-0">
      <div className="containerFluid">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mx-auto curatedContainer order-xl-2 order-lg-2 order-md-2 order-sm-1 order-1">
            <div className="artistBodyImage"></div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start  m-xl-auto m-lg-auto m-md-auto  mx-sm-auto  mt-sm-auto  mx-auto mt-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="row align-items-center justify-content-center">
              <div className="curatedHeading artistCuratedHeading mx-auto text-xl-start text-lg-start text-md-start col-7 mt-sm-5 mt-5 p-0">
                Go live with Ombré
              </div>
              <div className="curatedDescription col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 text-xl-start text-lg-start text-md-start d-none d-xl-block d-lg-block d-md-block  p-0">
                Jam on Jamroom! Live Stream your music from anywhere.
              </div>
              <div className="curatedDescription col-lg-9 col-md-9 col-sm-10 col-10 p-0 d-block d-md-none text-sm-center text-center">
                Live Stream your music from anywhere, only on the Ombré app !
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="containerFluid">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mx-auto curatedContainer order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2">
            <div className="artistBodyImage2 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-5 mt-5"></div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start  m-xl-auto m-lg-auto m-md-auto  mx-sm-auto  mt-sm-auto  mx-auto mt-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="row align-items-center justify-content-center">
              <div className="mx-auto curatedHeading artistCuratedHeading text-xl-start text-lg-start text-md-start mt-sm-5 mt-5 col-xl-8 col-lg-8 col-md-8">
                Grow your Fanbase
              </div>
              <div className="mx-auto curatedDescription col-xl-8 col-lg-8 col-md-8 col-sm-10 col-10 text-xl-start text-lg-start text-md-start">
                Engage with fans in a way never experienced elsewhere. Our
                <br />
                platform ensures your fans never miss your music.
              </div>
              {/* <div className="curatedDescription col-lg-9 col-md-9 col-sm-12 col-12 p-0 d-block d-md-none text-sm-center text-center">
                Live Stream your music from anywhere, only on the Ombré app !
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="containerFluid">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mx-auto mt-5 curatedContainer order-xl-2 order-lg-2 order-md-2 order-sm-1 order-1">
            <div className="artistBodyImage3"></div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start  m-xl-auto m-lg-auto m-md-auto  mx-sm-auto  mt-sm-auto  mx-auto mt-auto order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="row ">
              <div className=" mx-auto curatedHeading artistCuratedHeading text-xl-start text-lg-start text-md-start mt-sm-5 mt-5 col-xl-9 col-lg-9 col-md-9 p-0">
                Monetize your Performances
              </div>
              <div className=" mx-auto curatedDescription col-xl-9 col-lg-9 col-md-9 col-sm-10 col-10 text-xl-start text-lg-start text-md-start p-0">
                Earn with the power of live <br /> streaming, only on Ombré.
                <br /> Get sponsored requests from your
                <br /> very own fans !
              </div>
              {/* <div className="curatedDescription col-lg-9 col-md-9 col-sm-12 col-12 p-0 d-block d-md-none text-sm-center text-center">
                Live Stream your music from anywhere, only on the Ombré app !
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="containerFluid">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mx-auto mt-5 curatedContainer order-xl-1 order-lg-1 order-md-1 order-sm-2 order-2">
            <div className="artistBodyImage4 row flex-column  justify-content-center align-items-center p-auto">
              <div className="row flex-column  justify-content-center align-items-center p-0">
                <img
                  src={portFolioImage}
                  className="portfolioImage border-white mb-3"
                />
                <div className="portfolioTitle">Sean Garnier</div>
                <div className="portfolioDescription">
                  Singer | Producer | Beatboxer
                </div>
                <img className="linkGif" src={linkGIF} />
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 text-xl-start  m-xl-auto m-lg-auto m-md-auto  mx-sm-auto  mt-sm-auto  mx-auto mt-auto mb-5 order-xl-1 order-lg-1 order-md-1  order-sm-2 order-2 p-0">
            <div className="row align-items-center justify-content-center">
              <div className="curatedHeading p-0 artistCuratedHeading text-xl-start text-lg-start text-md-start mt-sm-5 mt-5 col-xl-9 col-lg-9 col-md-9 col-sm-10 col-10 p-0">
                Launch your artist Portfolio
              </div>
              <div className="curatedDescription col-xl-9 col-lg-9 col-md-9 col-sm-10 col-10 text-xl-start text-lg-start text-md-start p-0">
                Build your own music website.
                <br /> Add your songs, videos, photos and <br /> info and we
                generate a beautiful portfolio for you. Add the link to
                instagram bio.
              </div>
              {/* <div className="curatedDescription col-lg-9 col-md-9 col-sm-12 col-12 p-0 d-block d-md-none text-sm-center text-center">
                Live Stream your music from anywhere, only on the Ombré app !
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BodyDescription;



// WEBPACK FOOTER //
// ./src/pages/Artist/components/BodyDescription.jsx